import { get, pickBy } from 'lodash';
import { connect } from 'react-redux';
import { compose, branch, lifecycle } from 'recompose';

import { logImpression } from 'store/experiment/actions';
import mapDispatchToActions from 'store/helpers/mapDispatchToActions';
import experimentSelector from 'store/selectors/experiment';

import { TrackingClient } from '@sparefoot/tracking-client';

export const INACTIVE_EXPERIMENT = 'inactive';

export const getExperimentTreatment = (
	experimentName,
	bucket,
	forcedBucket,
	defaultVariation = 'control'
) => {
	const buckets = {
		...forcedBucket,
		...pickBy(bucket, (value) => value !== INACTIVE_EXPERIMENT),
	};
	const variation = get(buckets, experimentName) || INACTIVE_EXPERIMENT;
	if (variation === INACTIVE_EXPERIMENT) {
		return defaultVariation;
	}

	return variation;
};

// eslint-disable-next-line max-len
export const isExperimentActive = (experimentName, bucket) =>
	(get(bucket, experimentName) || INACTIVE_EXPERIMENT) !==
	INACTIVE_EXPERIMENT;


export const logExperimentImpression = (
	experimentName,
	experimentVariation
) => {
	if (typeof window !== 'undefined') {
		TrackingClient.trackExperimentView({
			category: experimentName,
			label: `Phlag ${experimentName} ${experimentVariation}`,
			experiment_source: 'Phlag',
			experiment_id: experimentName,
			variant_id: experimentVariation,
		});
	}
};

// Branches a component tree based on active and forced experiments
export const experimentBranch = (name, variation, render) =>
	compose(
		connect(experimentSelector, { logImpression }, mapDispatchToActions),
		lifecycle({
			componentDidMount() {
				if (isExperimentActive(name, this.props.bucket)) {
					this.props.actions.logImpression(name);
				}
			},
		}),
		branch(({ bucket, forcedBucket }) => {
			const bucketedVariation = getExperimentTreatment(
				name,
				bucket,
				forcedBucket
			);
			return typeof variation === 'string'
				? variation === bucketedVariation
				: variation.includes(bucketedVariation);
		}, render)
	);
